import ListingsRoutingResolver from './ListingRoutingResolver';

class AccountingSellListingResolver extends ListingsRoutingResolver {

    constructor() {
        super()
        this.key = "accounting-sell"
    }
}

export default AccountingSellListingResolver
